import { createTheme } from "@mantine/core";

export const theme = createTheme({
  primaryColor: "chocolate",
  colors: {
    chocolate: [
      "#faf4f0",
      "#ece0d8",
      "#d8bdab",
      "#c5987b",
      "#b67953",
      "#ad6739",
      "#a95e2c",
      "#944f20",
      "#83461a",
      "#723b11",
    ],
  },
  defaultRadius: "md",
  fontFamily: "Inter, system-ui, sans-serif",
  components: {
    // Loader sekiz yerde kullanılıyordu ve üç farklı görünümdeydi (biri chocolate, ikisi teal,
    // kalanı renksiz). Varsayılanı burada tanımlayınca çağrı yerlerinde prop vermeye gerek
    // kalmıyor ve yeni bir Loader eklendiğinde de kendiliğinden uyumlu geliyor.
    Loader: { defaultProps: { color: "chocolate" } },
  },
});
